export default {
  blanklayout: () => import("/vercel/path0/layouts/blanklayout.vue").then(m => m.default || m),
  checkout: () => import("/vercel/path0/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  layoutcompleto: () => import("/vercel/path0/layouts/layoutcompleto.vue").then(m => m.default || m),
  painel: () => import("/vercel/path0/layouts/painel.vue").then(m => m.default || m)
}